export default "__VITE_ASSET__BQK48uq___"